/**
 * Copy för Mitt hem-presentationen.
 *
 * Beskriver bostadens vy så som den är tänkt att fungera. Gatuchatten och underhållsplanen
 * ligger senare i ordningen och bär en diskret `vision`-markering med streckade konturer.
 *
 * Siffrorna är exempel på vad en vy visar — aldrig påståenden om spridning eller resultat.
 */

export const BRICKOR = [
    { id: 'varme', etikett: 'Värme', kombo: 'grön' as const },
    { id: 'el', etikett: 'El', kombo: 'grön' as const },
    { id: 'sopor', etikett: 'Sophämtning', kombo: 'grön' as const },
    { id: 'planlosning', etikett: 'Planlösning', kombo: 'blå' as const },
    { id: 'dokumentation', etikett: 'Dokumentation', kombo: 'blå' as const },
    { id: 'modell', etikett: '3D-modell', kombo: 'blå' as const },
    { id: 'gatan', etikett: 'Gatuchatten', kombo: 'lila' as const },
    { id: 'kanaler', etikett: 'Kanaler', kombo: 'lila' as const },
    { id: 'offerter', etikett: 'Offerter', kombo: 'lila' as const }
];

/** Ett dygns spotpris i öre/kWh, SE3. Formen är typisk: natt lågt, morgon och kväll högt. */
export const SPOTPRIS = [
    28, 24, 22, 21, 23, 31, 52, 88, 104, 96, 74, 61, 55, 52, 58, 69, 92, 118, 126, 104, 78, 58, 42, 33
];

export const SAMTALSLÄGEN = [
    {
        nyckel: 'grupp',
        etikett: 'Grupp',
        rubrik: 'Gimågatan',
        rader: [
            ['Ahmed', 'Någon som vill dela på en bil med släp till återvinningscentralen i helgen?'],
            ['Mira', 'Jag är med.'],
            ['Karin', 'Jag med.']
        ]
    },
    {
        nyckel: 'kanal',
        etikett: 'Kanal',
        rubrik: 'Driftstörningar',
        rader: [
            ['Mira', 'Hissen i port 3 står still igen.'],
            ['Johan', 'Felanmält till Kone, de kommer i morgon.'],
            ['Karin', 'Tack. Lägger en lapp i porten.']
        ]
    },
    {
        nyckel: 'enskild',
        etikett: 'Enskild chatt',
        rubrik: 'Till lgh 1102',
        rader: [
            ['Du', 'Hej! Är det du som har cykeln med gul ram?'],
            ['Grannen', 'Ja, ska jag flytta den?'],
            ['Du', 'Ingen brådska, undrade bara.']
        ]
    },

];

export const UNDERHÅLLSPOSTER = [
    { id: 'u1', åtgärd: 'Stambyte', år: 2029, kostnad: '14 200 000 kr' },
    { id: 'u2', åtgärd: 'Fasadrenovering', år: 2032, kostnad: '6 800 000 kr' },
    { id: 'u3', åtgärd: 'Takomläggning', år: 2036, kostnad: '4 100 000 kr' },
    { id: 'u4', åtgärd: 'Hissbyte', år: 2041, kostnad: '3 300 000 kr' },
    { id: 'u5', åtgärd: 'Fönsterbyte', år: 2047, kostnad: '5 600 000 kr' }
];

export const DOKUMENT = [
    { id: 'd1', namn: 'Bygglov 1962', källa: 'Stockholms Bygg- och plantjänsten' },
    { id: 'd2', namn: 'Ritning plan 4', källa: 'Bygglovsarkivet' },
    { id: 'd3', namn: 'Energideklaration', källa: 'Boverket' },
    { id: 'd4', namn: 'Relationshandling stam', källa: 'Föreningen' }
];
